module.exports = "/_next/static/images/642714409d5a2681257a7b1c67946bac-nubanker-xpeer@2x.jpg.webp";